/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BatchDocumentExportReqVo,
  PackingCompleteReqVo,
  PackingSaveReqVo,
  ResponseBoolean,
  ResponseGoodsPackedCheckResVo,
  ResponseListPackingItemVo,
  ResponsePackingInitResVo,
} from '../models/index';
import {
    BatchDocumentExportReqVoFromJSON,
    BatchDocumentExportReqVoToJSON,
    PackingCompleteReqVoFromJSON,
    PackingCompleteReqVoToJSON,
    PackingSaveReqVoFromJSON,
    PackingSaveReqVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseGoodsPackedCheckResVoFromJSON,
    ResponseGoodsPackedCheckResVoToJSON,
    ResponseListPackingItemVoFromJSON,
    ResponseListPackingItemVoToJSON,
    ResponsePackingInitResVoFromJSON,
    ResponsePackingInitResVoToJSON,
} from '../models/index';

export interface BoxesGoodsGoodsIdPackedGetRequest {
    goodsId: number;
}

export interface BoxesMaterialConsumptionExportGetRequest {
    orderIds: Array<number>;
}

export interface BoxesPackingDetailsBoxesSummaryGetRequest {
    orderId: number;
}

export interface BoxesPackingDetailsCompletePostRequest {
    packingCompleteReqVo?: PackingCompleteReqVo;
}

export interface BoxesPackingDetailsExportGetRequest {
    orderId: number;
}

export interface BoxesPackingDetailsInitGetRequest {
    orderId: number;
}

export interface BoxesPackingDetailsInvoiceExportGetRequest {
    orderId: number;
}

export interface BoxesPackingDetailsInvoicePackingExportGetRequest {
    orderId: number;
}

export interface BoxesPackingDetailsInvoicePackingsExportPostRequest {
    batchDocumentExportReqVo?: BatchDocumentExportReqVo;
}

export interface BoxesPackingDetailsInvoicesExportPostRequest {
    batchDocumentExportReqVo?: BatchDocumentExportReqVo;
}

export interface BoxesPackingDetailsModifyPostRequest {
    packingCompleteReqVo?: PackingCompleteReqVo;
}

export interface BoxesPackingDetailsPackingDetailExportGetRequest {
    orderId: number;
    mode: string;
}

export interface BoxesPackingDetailsPackingListsExportPostRequest {
    batchDocumentExportReqVo?: BatchDocumentExportReqVo;
}

export interface BoxesPackingDetailsPostRequest {
    packingSaveReqVo?: PackingSaveReqVo;
}

/**
 * 
 */
export class BoxControllerApi extends runtime.BaseAPI {

    /**
     * 箱子管理·商品是否已装箱或装托（详情页修改商品验证）
     * 箱子管理·商品是否已装箱或装托（详情页修改商品验证）
     */
    async boxesGoodsGoodsIdPackedGetRaw(requestParameters: BoxesGoodsGoodsIdPackedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGoodsPackedCheckResVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling boxesGoodsGoodsIdPackedGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/goods/{goodsId}/packed`.replace(`{${"goodsId"}}`, encodeURIComponent(String(requestParameters['goodsId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGoodsPackedCheckResVoFromJSON(jsonValue));
    }

    /**
     * 箱子管理·商品是否已装箱或装托（详情页修改商品验证）
     * 箱子管理·商品是否已装箱或装托（详情页修改商品验证）
     */
    async boxesGoodsGoodsIdPackedGet(requestParameters: BoxesGoodsGoodsIdPackedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGoodsPackedCheckResVo> {
        const response = await this.boxesGoodsGoodsIdPackedGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 箱子管理·物料消耗批量导出
     * 箱子管理·物料消耗批量导出
     */
    async boxesMaterialConsumptionExportGetRaw(requestParameters: BoxesMaterialConsumptionExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['orderIds'] == null) {
            throw new runtime.RequiredError(
                'orderIds',
                'Required parameter "orderIds" was null or undefined when calling boxesMaterialConsumptionExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderIds'] != null) {
            queryParameters['orderIds'] = requestParameters['orderIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/material-consumption/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 箱子管理·物料消耗批量导出
     * 箱子管理·物料消耗批量导出
     */
    async boxesMaterialConsumptionExportGet(requestParameters: BoxesMaterialConsumptionExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.boxesMaterialConsumptionExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 测运费·订单已包装箱子信息
     * 测运费·订单已包装箱子信息
     */
    async boxesPackingDetailsBoxesSummaryGetRaw(requestParameters: BoxesPackingDetailsBoxesSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListPackingItemVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling boxesPackingDetailsBoxesSummaryGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/boxes-summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListPackingItemVoFromJSON(jsonValue));
    }

    /**
     * 测运费·订单已包装箱子信息
     * 测运费·订单已包装箱子信息
     */
    async boxesPackingDetailsBoxesSummaryGet(requestParameters: BoxesPackingDetailsBoxesSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListPackingItemVo> {
        const response = await this.boxesPackingDetailsBoxesSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 箱子管理·包装完成
     * 箱子管理·包装完成
     */
    async boxesPackingDetailsCompletePostRaw(requestParameters: BoxesPackingDetailsCompletePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/complete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PackingCompleteReqVoToJSON(requestParameters['packingCompleteReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 箱子管理·包装完成
     * 箱子管理·包装完成
     */
    async boxesPackingDetailsCompletePost(requestParameters: BoxesPackingDetailsCompletePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.boxesPackingDetailsCompletePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 旧版装箱单。箱/托合包按构成展开为基础商品， 品名、产地证英文品名、HS、产地类型均取基础商品。 箱子管理·装箱单导出
     * 箱子管理·装箱单导出
     */
    async boxesPackingDetailsExportGetRaw(requestParameters: BoxesPackingDetailsExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling boxesPackingDetailsExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 旧版装箱单。箱/托合包按构成展开为基础商品， 品名、产地证英文品名、HS、产地类型均取基础商品。 箱子管理·装箱单导出
     * 箱子管理·装箱单导出
     */
    async boxesPackingDetailsExportGet(requestParameters: BoxesPackingDetailsExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.boxesPackingDetailsExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 箱子管理·订单包装数据初始化查询
     * 箱子管理·订单包装数据初始化查询
     */
    async boxesPackingDetailsInitGetRaw(requestParameters: BoxesPackingDetailsInitGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePackingInitResVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling boxesPackingDetailsInitGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/init`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePackingInitResVoFromJSON(jsonValue));
    }

    /**
     * 箱子管理·订单包装数据初始化查询
     * 箱子管理·订单包装数据初始化查询
     */
    async boxesPackingDetailsInitGet(requestParameters: BoxesPackingDetailsInitGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePackingInitResVo> {
        const response = await this.boxesPackingDetailsInitGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 旧版商业发票。电商快递只出基础商品；其余类型按箱/托导出，合包同样展开为基础商品。 箱子管理·发票导出
     * 箱子管理·发票导出
     */
    async boxesPackingDetailsInvoiceExportGetRaw(requestParameters: BoxesPackingDetailsInvoiceExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling boxesPackingDetailsInvoiceExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/invoice/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 旧版商业发票。电商快递只出基础商品；其余类型按箱/托导出，合包同样展开为基础商品。 箱子管理·发票导出
     * 箱子管理·发票导出
     */
    async boxesPackingDetailsInvoiceExportGet(requestParameters: BoxesPackingDetailsInvoiceExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.boxesPackingDetailsInvoiceExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 新版箱单发票。明细与旧装箱单相同（合包展开为基础商品，三字段取基础商品），仅版式按三字段合并。 箱子管理·新版箱单发票下载（一个 Excel、两个 Sheet）
     * 箱子管理·新版箱单发票下载（一个 Excel、两个 Sheet）
     */
    async boxesPackingDetailsInvoicePackingExportGetRaw(requestParameters: BoxesPackingDetailsInvoicePackingExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling boxesPackingDetailsInvoicePackingExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/invoice-packing/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 新版箱单发票。明细与旧装箱单相同（合包展开为基础商品，三字段取基础商品），仅版式按三字段合并。 箱子管理·新版箱单发票下载（一个 Excel、两个 Sheet）
     * 箱子管理·新版箱单发票下载（一个 Excel、两个 Sheet）
     */
    async boxesPackingDetailsInvoicePackingExportGet(requestParameters: BoxesPackingDetailsInvoicePackingExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.boxesPackingDetailsInvoicePackingExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 出库计划批量新版箱单发票。按传入的订单 ID 数组导出； 所有订单放进同一张发票表和装箱单表，只保留一份表头；各订单内部整合，跨订单不合并商品。 出库计划·批量新版箱单发票下载
     * 出库计划·批量新版箱单发票下载
     */
    async boxesPackingDetailsInvoicePackingsExportPostRaw(requestParameters: BoxesPackingDetailsInvoicePackingsExportPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/invoice-packings/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchDocumentExportReqVoToJSON(requestParameters['batchDocumentExportReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 出库计划批量新版箱单发票。按传入的订单 ID 数组导出； 所有订单放进同一张发票表和装箱单表，只保留一份表头；各订单内部整合，跨订单不合并商品。 出库计划·批量新版箱单发票下载
     * 出库计划·批量新版箱单发票下载
     */
    async boxesPackingDetailsInvoicePackingsExportPost(requestParameters: BoxesPackingDetailsInvoicePackingsExportPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.boxesPackingDetailsInvoicePackingsExportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 出库计划·批量发票导出
     * 出库计划·批量发票导出
     */
    async boxesPackingDetailsInvoicesExportPostRaw(requestParameters: BoxesPackingDetailsInvoicesExportPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/invoices/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchDocumentExportReqVoToJSON(requestParameters['batchDocumentExportReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 出库计划·批量发票导出
     * 出库计划·批量发票导出
     */
    async boxesPackingDetailsInvoicesExportPost(requestParameters: BoxesPackingDetailsInvoicesExportPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.boxesPackingDetailsInvoicesExportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 箱子管理·包装明细修改（仅包装状态置未包装）
     * 箱子管理·包装明细修改（仅包装状态置未包装）
     */
    async boxesPackingDetailsModifyPostRaw(requestParameters: BoxesPackingDetailsModifyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/modify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PackingCompleteReqVoToJSON(requestParameters['packingCompleteReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 箱子管理·包装明细修改（仅包装状态置未包装）
     * 箱子管理·包装明细修改（仅包装状态置未包装）
     */
    async boxesPackingDetailsModifyPost(requestParameters: BoxesPackingDetailsModifyPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.boxesPackingDetailsModifyPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 箱子管理·包装明细表下载
     * 箱子管理·包装明细表下载
     */
    async boxesPackingDetailsPackingDetailExportGetRaw(requestParameters: BoxesPackingDetailsPackingDetailExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling boxesPackingDetailsPackingDetailExportGet().'
            );
        }

        if (requestParameters['mode'] == null) {
            throw new runtime.RequiredError(
                'mode',
                'Required parameter "mode" was null or undefined when calling boxesPackingDetailsPackingDetailExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/packing-detail/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 箱子管理·包装明细表下载
     * 箱子管理·包装明细表下载
     */
    async boxesPackingDetailsPackingDetailExportGet(requestParameters: BoxesPackingDetailsPackingDetailExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.boxesPackingDetailsPackingDetailExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 出库计划·批量装箱单导出
     * 出库计划·批量装箱单导出
     */
    async boxesPackingDetailsPackingListsExportPostRaw(requestParameters: BoxesPackingDetailsPackingListsExportPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details/packing-lists/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchDocumentExportReqVoToJSON(requestParameters['batchDocumentExportReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 出库计划·批量装箱单导出
     * 出库计划·批量装箱单导出
     */
    async boxesPackingDetailsPackingListsExportPost(requestParameters: BoxesPackingDetailsPackingListsExportPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.boxesPackingDetailsPackingListsExportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 箱子管理·保存包装明细（箱子页面）
     * 箱子管理·保存包装明细（箱子页面）
     */
    async boxesPackingDetailsPostRaw(requestParameters: BoxesPackingDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/boxes/packing-details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PackingSaveReqVoToJSON(requestParameters['packingSaveReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 箱子管理·保存包装明细（箱子页面）
     * 箱子管理·保存包装明细（箱子页面）
     */
    async boxesPackingDetailsPost(requestParameters: BoxesPackingDetailsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.boxesPackingDetailsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
